<template>
  <transition name="fade">
    <div class="dialog" v-if="show">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    withClose: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    if (this.persistent) {
    }
  },
  methods: {
    checkOutsideClick() {},
  },
}
</script>

<style lang="scss" src="./IcDialog.scss" />
